__turbopack_context__.v({
  "className": "noto_sans_tc_b2407e6d-module__HYtJTa__className",
  "variable": "noto_sans_tc_b2407e6d-module__HYtJTa__variable",
});
